module.exports = __webpack_public_path__ + "img/turbo_on.764cde65.png";